import React, { useEffect, useState } from "react";
import Modal from "../design/Shared/Modal";
import { DropdownMenu } from "../design/Shared/Select/DropdownMenu";
import trash from "../../images/icons/trash.svg";
import edit from "../../images/icons/edit.svg";
import { isMenuDisabled } from "../../business/helper/Singleton";

const TruncatedTextWithMenu = ({
  text,
  maxLength = 21,
  onDelete,
  onRename,
}) => {
  const [isRenameDialogOpen, setIsRenameDialogOpen] = useState(false);
  const [newName, setNewName] = useState(text);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(isMenuDisabled.state);

  useEffect(() => {
    const event = () => setIsDisabled(isMenuDisabled.state);
    isMenuDisabled.subscribe(event);

    return () => {
      isMenuDisabled.unsubscribe(event);
    };
  }, []);
  // const truncateString = (str) => {
  //   if (!str) return "";
  //   if (typeof str !== "string") {
  //     str = String(str);
  //   }
  //   if (str.length <= maxLength) {
  //     return str;
  //   }
  //   return `${str.slice(0, maxLength - 3)}...`;
  // };

  const handleRenameClick = () => {
    setNewName(text);
    setIsRenameDialogOpen(true);
  };

  const handleRenameSubmit = async (e) => {
    e.preventDefault();

    if (!newName.trim() || newName === text) {
      setIsRenameDialogOpen(false);
      return;
    }

    setIsLoading(true);
    try {
      await onRename(newName.trim());
      setIsRenameDialogOpen(false);
    } catch (error) {
      console.error("Failed to rename:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // TODO: add drop down onContextMenu={}{" "}
  return (
    <>
      <div className="flex items-center h-6 justify-between">
        <p className="truncate">{text}</p>

        <DropdownMenu>
          <DropdownMenu.Trigger
            disabled={isDisabled}
            className="sm:opacity-0 group-hover:!opacity-100 disabled:cursor-not-allowed"
          />
          <DropdownMenu.Content className={"-left-6 sm:left-20"}>
            <DropdownMenu.PrimitiveItem
              onClick={(event) => {
                event.stopPropagation();
                handleRenameClick();
              }}
            >
              <img src={edit} alt="edit" />
              Rename
            </DropdownMenu.PrimitiveItem>
            <DropdownMenu.PrimitiveItem
              onClick={(event) => {
                event.stopPropagation();
                onDelete();
              }}
            >
              <img src={trash} alt="trash" />
              Delete
            </DropdownMenu.PrimitiveItem>
          </DropdownMenu.Content>
        </DropdownMenu>
      </div>

      {/* <div className="dropdown">
        <button
          className="btn btn-sm btn-light border-0 p-1"
          type="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <MoreHorizontal className="h-4 w-4 text-secondary" />
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li>
            <button
              className="dropdown-item d-flex align-items-center gap-2"
              onClick={handleRenameClick}
            >
              <Pencil className="h-4 w-4" />
              Rename
            </button>
          </li>
          <li>
            <button
              className="dropdown-item text-danger d-flex align-items-center gap-2"
              onClick={onDelete}
            >
              <Trash2 className="h-4 w-4" />
              Delete
            </button>
          </li>
        </ul>
      </div> */}

      {isRenameDialogOpen && (
        <Modal
          open={isRenameDialogOpen}
          onClose={() => setIsRenameDialogOpen(false)}
        >
          <div className="font-notosans text-xl text-dark-blue-100 font-bold py-4 px-6 border-b border-whitesmoke-100 flex items-center justify-between">
            <h5 id="renameDialogLabel">Rename your Favorite</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setIsRenameDialogOpen(false)}
              aria-label="Close"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="hover:cursor-pointer"
                // onClick={onClose}
              >
                <path
                  d="M4 4L16 16M16 4L4 16"
                  stroke="#303C54"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
          <form
            onSubmit={handleRenameSubmit}
            className="p-6 flex flex-col gap-8"
          >
            <div className="flex flex-col gap-2">
              <label
                htmlFor="name"
                className="font-semibold text-dark-blue-100"
              >
                Favorite Name
              </label>
              <input
                type="text"
                className="px-6 py-1.5 leading-6 rounded-lg bg-white text-dimgray-200 border border-whitesmoke-100 peer focus:outline-none focus:border-blue-200 placeholder:text-dimgray-400"
                id="name"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Enter new name"
                autoComplete="off"
                autoFocus
              />
            </div>

            <div className="flex gap-3 -mt-4 justify-end">
              <button
                onClick={() => setIsRenameDialogOpen(false)}
                disabled={isLoading}
                className="border rounded-2xl py-3 w-[92px] border-dimgray-200 text-dark-blue-100 font-semibold leading-4.5"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!newName?.trim() || newName === text || isLoading}
                className="cursor-pointer border rounded-2xl py-3 w-[92px] border-dimgray-200 bg-dark-blue-100 text-white font-bold leading-4.5"
              >
                {isLoading ? "Renaming..." : "Rename"}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
};

export default TruncatedTextWithMenu;
